import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import UserControl from "../Dialogs/UserControl";
dayjs.extend(relativeTime);

const ProjectCard = ({ project, open }) => (
  <Card style={{ marginTop: 30, marginBottom: 30 }} sx={{ maxWidth: 800 }} onClick={() => open(project.id)}>
    <CardMedia sx={{ height: 140 }} image={project.map} title="green iguana" />
    <CardContent>
      <Typography
        variant="h5"
        underline="hover"
        // href={`/project/${props.projectId}/checklist-templates/${obs.id}/edit`}
        color="secondary.main"
      >
        {project.Name}
      </Typography>
      <Typography variant="h6" color="secondary.light">
        {project["Short Name"]}
      </Typography>

      <UserControl isCreator={true} user={project["Created By"].toString()} uid={project?.uid} />

      <Typography variant="caption" color="secondary.light">
        Created Date:
      </Typography>

      <Typography style={{ marginLeft: 4 }} variant="caption">
        {`${new Date(
          project["Created Date"].seconds * 1000,
        ).toLocaleDateString()} (${dayjs(
          new Date(project["Created Date"].seconds * 1000),
        ).fromNow()})`}
      </Typography>
    </CardContent>
    {/* <CardActions>
      <Button
        variant="contained"
        onClick={() => open(project.id)}
        startIcon={<OpenInNewIcon />}
        size="small"
      >
        Open
      </Button>
    </CardActions> */}
  </Card>
);
export default ProjectCard;
